export default __webpack_public_path__ + "static/media/Gas_sensor.8092023a.svg";